module.exports = __webpack_public_path__ + "static/revival-afa34d1d7a99462069662e3042d0b48a.jpg";